/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Row, Col, Form } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import { withTranslation } from 'react-i18next';
import { Loader } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ClaimDetailsSVG } from '../../img/GlobalSVG';
//import axios from 'axios';
import GetAdminConfiguration from '../../api/GetAdminConfig';
import APIEndpoints from '../../api/APIEndpoints';
import HttpErrorHandler from '../../errorhandling/HttpErrorHandler';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import RetryAPI from '../../api/RetryAPI';
import ClientError from '../../errorhandling/ClientError';
import './Registrationsetup.scss';
import RecoveryFields from '../EmailReset/RecoveryFields';
import { axiosInstance } from '../../../api/axios';
import Header from '../../components/common/Header/Header';
import PasswordResetSkeleton from './PasswordResetSkeleton';
import CustomClientError from '../../errorhandling/CustomClientError';
import ToastMessage from '../common/ToastMessage';
import GenericButton from '../../../Components/GenericButton/GenericButton';

const getAdminConfigData = '';
const resetPwdData = '';
let resetOptionIdx = 0;

class PasswordReset extends Component {
  constructor(props) {
    super(props);

    this.state = {
      LoadingPwdRecovery: true,
      SavingPwdRecovery: false,
      clientError: false,
      serverError: false,
      resetDisclaimer: '',
      resetAllowRecoveryUsingAltMail: false,
      isAPIFailed: false,
      isNotFound: false,
      resetOptions: {},
    };
    this.RegistrationSave = this.RegistrationSave.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  RegistrationSave = () => {
    this.setState({ SavingPwdRecovery: true });
    GetAdminConfiguration.resetDisclaimer[resetOptionIdx] =
      this.state.resetDisclaimer;
    GetAdminConfiguration.resetAllowRecoveryUsingAltMail[resetOptionIdx] =
      this.state.resetAllowRecoveryUsingAltMail === true ? 'YES' : 'NO';
    console.log(
      'Reset Password - GetAdminConfiguration: ',
      GetAdminConfiguration,
    );
    this.AddOrUpdateResetPwd();
  };

  AddOrUpdateResetPwd = async () => {
    let iIndex;

    const resetPwdRec = {
      ResetOptions: [
        {
          OID: GetAdminConfiguration.resetOid[resetOptionIdx],
          RecordType: 'Password',
          Disclaimer: GetAdminConfiguration.resetDisclaimer[resetOptionIdx],
          AllowRecoveryUsingAltMail:
            GetAdminConfiguration.resetAllowRecoveryUsingAltMail[
              resetOptionIdx
            ],
          FirstName: GetAdminConfiguration.resetFirstName[resetOptionIdx],
          LastName: GetAdminConfiguration.resetLastName[resetOptionIdx],
          DateOfBirth: GetAdminConfiguration.resetDateOfBirth[resetOptionIdx],
          SocialSecurityNumber: GetAdminConfiguration.resetSSN[resetOptionIdx],
          CertificateNumber:
            GetAdminConfiguration.resetMemberID[resetOptionIdx],
          AlternateID1: GetAdminConfiguration.resetAlternateID1[resetOptionIdx],
          AlternateID2: GetAdminConfiguration.resetAlternateID2[resetOptionIdx],
          MedicareID: GetAdminConfiguration.resetMedicareID[resetOptionIdx],
          PostalCode: GetAdminConfiguration.resetPostalCode[resetOptionIdx],
          Relationship: GetAdminConfiguration.resetRelationship[resetOptionIdx],
          Email: GetAdminConfiguration.resetAlternateEmail[resetOptionIdx],
          PhoneNumber: GetAdminConfiguration.resetPhoneNumber[resetOptionIdx],
        },
      ],
    };

    let resetPwdResponse = null,
      resetPwdDataResp;
    let EncrptedResp;

    RetryAPI.setResponseReceived(false);
    RetryAPI.resetRetryCount();
    while (RetryAPI.performRetry()) {
      try {
        if (GetAdminConfiguration.resetOid[resetOptionIdx] == null) {
          EncrptedResp = await axiosInstance.post(
            APIEndpoints.addResetPasswordResources(),
            resetPwdRec,
          );
        } else {
          EncrptedResp = await axiosInstance.put(
            APIEndpoints.updateResetPasswordResources(),
            resetPwdRec,
          );
        }

        resetPwdResponse = EncrptedResp;

        resetPwdDataResp = resetPwdResponse.data;
        if (
          resetPwdResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
          resetPwdResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
        ) {
          RetryAPI.resetRetryCount();
          RetryAPI.setResponseReceived(true);
          console.log('Successful resetPwdResponse: ', resetPwdResponse);
        } else {
          RetryAPI.incrementRetryCount();
          RetryAPI.setResponseReceived(false);
          RetryAPI.setErrorCode(resetPwdResponse.status);
          console.log('resetPwdResponse Error code:', resetPwdResponse.status);
        }

        if (RetryAPI.getResponseReceived()) break;
      } catch (error) {
        let errorMessage = '';
        //var requestAborted = '';

        console.log('Entering Catch');
        if (error) {
          errorMessage = error.toString();
          //requestAborted = errorMessage.match(/aborted/i);
          RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
        }
        if (error.response) {
          RetryAPI.setErrorCode(error.response.status);
        }

        //if (axios.isCancel(error)) {
        ////////////////console.log('Previous request canceled, new request is send', error.message);
        //}

        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
      }
      console.log('Exiting Catch');
    }

    if (RetryAPI.retryFailed()) {
      console.log('Retry Failed');
      const errorCode = RetryAPI.getErrorCode();
      HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');

      //Process Client Errors
      if (
        HttpErrorHandler.ProcessedClientErrors(
          errorCode,
          'view resetPwdResponse. ',
        )
      ) {
        toast.error(
          <ToastMessage
            type="error"
            title="Password Recovery Configuration Setup."
            subTitle="Error occurred while saving Password Recovery configuration Setup."
          />,
        );
        //Display Error Message -No claims submitted in the past six months.
        this.setState({ clientError: true });
        this.setState({ SavingPwdRecovery: false });
      } else {
        //Handle Excpetion
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to render your resetPwdResponse now.',
          )
        ) {
          console.log('Setting Server Error');
          this.setState({ serverError: true });
        }
      }
    } else {
      toast.success(
        <ToastMessage
          type="success"
          title="Password Recovery Configuration Setup"
          subTitle="Password Recovery Configuration Setup was saved successfully."
        />,
      );
      this.setState({ SavingPwdRecovery: false });
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getAdminConfig();
  }
  cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  getAdminConfig = async () => {
    let getAdminConfigResponse = null,
      getAdminConfigDataResp;
    let bFound = false;

    GetAdminConfiguration.setAdminConfigurationResp(null);

    RetryAPI.setResponseReceived(false);
    RetryAPI.resetRetryCount();
    while (RetryAPI.performRetry()) {
      try {
        const EncrptedResp = await axiosInstance.get(
          this.cacheBuster(APIEndpoints.getAdminConfigResources()),
        );
        getAdminConfigResponse = EncrptedResp;

        getAdminConfigDataResp = getAdminConfigResponse.data;

        if (
          getAdminConfigResponse.status ===
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200
        ) {
          GetAdminConfiguration.setAdminConfigurationResp(
            getAdminConfigDataResp,
          );
          RetryAPI.resetRetryCount();
          RetryAPI.setResponseReceived(true);
          console.log(
            'Successful getAdminConfigResponse: ',
            getAdminConfigResponse,
          );

          GetAdminConfiguration.ParseResetOptions();
          let getDisclaimer = '';
          for (
            let iIndex = 0;
            iIndex < GetAdminConfiguration.resetOptionsLength;
            iIndex++
          ) {
            console.log(
              'RECORD TYPE: ',
              GetAdminConfiguration.resetRecordType[iIndex],
            );
            if (GetAdminConfiguration.resetRecordType[iIndex] == 'Password') {
              resetOptionIdx = iIndex;
              getDisclaimer = GetAdminConfiguration.resetDisclaimer[iIndex];
              this.setState({
                resetDisclaimer: GetAdminConfiguration.resetDisclaimer[iIndex],
                resetAllowRecoveryUsingAltMail:
                  GetAdminConfiguration.resetAllowRecoveryUsingAltMail[
                    iIndex
                  ] == 'YES'
                    ? true
                    : false,
              });
              bFound = true;
            }
          }
          console.log(
            'resetAllowRecoveryUsingAltMail: ',
            this.state.resetAllowRecoveryUsingAltMail,
          );
          if (!bFound) resetOptionIdx = 1;

          const options =
            getAdminConfigDataResp &&
            getAdminConfigDataResp?.Response?.ResetOptions?.filter(
              (item) => item.RecordType === 'Password',
            );
          console.log('password options', options);

          const arr = [];
          options.map((option) => {
            if (option.Disclaimer === getDisclaimer) {
              arr.push(option);
            }
          });

          arr.length &&
            this.setState({
              resetOptions: arr[0],
            });
        } else {
          RetryAPI.incrementRetryCount();
          RetryAPI.setResponseReceived(false);
          RetryAPI.setErrorCode(getAdminConfigResponse.status);
          console.log(
            'getAdminConfigResponse Error code:',
            getAdminConfigResponse.status,
          );
        }

        if (RetryAPI.getResponseReceived()) break;
      } catch (error) {
        let errorMessage = '';
        this.setState({
          isAPIFailed: true,
        });
        if (error.toString().includes('404')) {
          this.setState({
            isNotFound: true,
          });
        }

        if (error) {
          errorMessage = error.toString();
          //requestAborted = errorMessage.match(/aborted/i);
          RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
        }
        if (error.response) {
          RetryAPI.setErrorCode(error.response.status);
        }

        //if (axios.isCancel(error)) {
        ////////////////console.log('Previous request canceled, new request is send', error.message);
        //}

        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
      }
    }

    if (RetryAPI.retryFailed()) {
      const errorCode = RetryAPI.getErrorCode();
      HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');

      //Process Client Errors
      if (
        HttpErrorHandler.ProcessedClientErrors(
          errorCode,
          'view getAdminConfigResponse. ',
        )
      ) {
        //Display Error Message -No claims submitted in the past six months.
        this.setState({ clientError: true });
        this.setState({ LoadingPwdRecovery: false });
      } else {
        //Handle Excpetion
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to render your getAdminConfigResponse now.',
          )
        ) {
          this.setState({ serverError: true });
        }
      }
      return;
    } else {
      this.setState({ LoadingPwdRecovery: false });
    }
  };

  handleChange = (event) => {
    console.log(event.target.name);
    console.log(event.target.checked);
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleInputChange(event) {
    console.log(event.target.name);
    console.log(event.target.value);
    this.setState({
      ...this.state,
      [event.target.name]: event.target.value,
    });
  }

  render() {
    const {
      backtoDashboard,
      serverError,
      clientError,
      LoadingPwdRecovery,
      SavingPwdRecovery,
      resetDisclaimer,
      resetAllowRecoveryUsingAltMail,
      isAPIFailed,
      isNotFound,
    } = this.state;

    console.log('render Called');

    if (serverError)
      return <Navigate to="/admin/server-error" push={true}></Navigate>;

    if (backtoDashboard) {
      return <Navigate to="/admin/dashboard" push={true}></Navigate>;
    }
    const { t } = this.props;

    return (
      <div>
        <Container fluid className="claims-details password-reset-form">
          <div className="toastify">
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>

          {!LoadingPwdRecovery && isAPIFailed ? (
            <Container className="px-0">
              {isNotFound ? (
                <CustomClientError
                  ErrorHeading="No data found!"
                  ErrorMessage="We are unable to render your response now. "
                  NoDataFound={true}
                />
              ) : (
                <CustomClientError
                  ErrorHeading="Something went wrong with request!"
                  ErrorMessage="Please try again."
                />
              )}
            </Container>
          ) : LoadingPwdRecovery ? (
            <PasswordResetSkeleton />
          ) : (
            <div>
              <Header
                linkTo={'/admin/admin-dashboard'}
                header={t('admin.pages.password_reset.module')}
              />

              <Row className="Payment-details">
                <Col className="padding-0">
                  <h3>Disclaimer</h3>
                </Col>
                <Col>
                  <TextField
                    style={{ borderColor: 'white' }}
                    id="outlined-multiline-static"
                    //label="disclaimer"
                    multiline
                    rows={4}
                    defaultValue={resetDisclaimer}
                    fullWidth
                    variant="outlined"
                    name="resetDisclaimer"
                    onChange={this.handleInputChange}
                  />
                </Col>
              </Row>
              <Row className="Payment-details">
                <Col className="padding-0">
                  <h3>Information to Validate</h3>
                  <p>
                    Define Additional Fields that will identify the Members in
                    the portal. Maximum 6 fields can be selected.{' '}
                  </p>
                  <p>
                    Recommended additional fields to find a unique member record
                    - First Name, Last Name, DOB and Postal code along with
                    Member ID or SSN. Other additional fields should be selected
                    for more security.
                  </p>
                </Col>
                <Col className="setup-form">
                  <RecoveryFields
                    iIndex={resetOptionIdx}
                    fields={this.state.resetOptions}
                  />
                </Col>
              </Row>
              <Row className="Payment-details password-policy">
                <Col className="padding-0">
                  <h3>Use Alternate Email</h3>
                  <p>
                    Select whether to send the details to Alternate Email ID
                  </p>
                  {/*<Form.Group id="formGridCheckbox1">
                  <Form.Check type="checkbox" label="Enable One Time Password"/>
            </Form.Group>  */}
                </Col>
                <Col>
                  <Form.Group id="formGridCheckboxrest" className="d-flex">
                    <Form.Label className="sr-only" for="Alternate1">
                      Alternate
                    </Form.Label>
                    <Form.Check
                      checked={resetAllowRecoveryUsingAltMail}
                      type="checkbox"
                      label="Allow to recover using Alternate Email"
                      id="Alternate"
                      onChange={this.handleChange}
                      name="resetAllowRecoveryUsingAltMail"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="Payment-details password-policy border-bottom-0">
                <Col className="float-right text-right">
                  {/*<Button variant="light" className='rec-settings'>Recommended Settings</Button> */}
                  <GenericButton
                    variant="primary"
                    disable={SavingPwdRecovery}
                    postLabel="SAVE"
                    onClick={this.RegistrationSave}
                  >
                    SAVE
                  </GenericButton>
                </Col>
              </Row>
            </div>
          )}

          {SavingPwdRecovery && (
            <div className="custom-loader mt-0 d-flex justify-content-end sr-only">
              <div className="loader-icon position-relative mr-4">
                <Loader
                  className="text-dark font-weight-bold loader-color marginTop-Login-loader"
                  size="small"
                  active
                />
              </div>
              <div className="text-dark font-weight-bold" role="alert">
                Saving Password Recovery Configuration Setup
                <span aria-hidden={true}>...</span>
              </div>
            </div>
          )}
        </Container>
      </div>
    );
  }
}
export default withTranslation()(PasswordReset);
